import { Pipe, PipeTransform } from '@angular/core';
import { Dividend, DividendType } from '@zero/statistics/domain';

@Pipe({
  name: 'filterEmptyDividend',
  standalone: true,
})
export class FilterEmptyDividendPipe implements PipeTransform {
  public transform(value: Dividend[], activeDividendType: DividendType): Dividend[] {
    if (!Array.isArray(value) || value.length === 0) {
      return [];
    }

    if (!activeDividendType) {
      return value;
    }

    return value.filter(({ forecastedPeriods, historicalPeriods }) => {
      const activePeriod = activeDividendType === DividendType.Forecast ? forecastedPeriods : historicalPeriods;
      return (activePeriod?.length ?? 0) > 0;
    });
  }
}
